import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState, fYear } from "../../../components/shared/GlobalState";
import {
  FaArrowLeft,
  FaPlus,
  FaCalendarAlt,
  FaDollarSign,
  FaUser,
  FaListAlt,
} from "react-icons/fa";

import {
  incomeSourceOptions,
  paymentStatusOption,
} from "../../../components/Data/DropDownData";

const IncomeDuesReceiptChild = ({ selectedRecord }) => {
  let navigate = useNavigate();
  const inputWidth = "230px";
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      boxShadow: "none", // This line disables the blue border
    }),
  };

  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [financial_year] = useState({
    value: user?.current_financial_year,
    label: user?.current_financial_year,
  });
  const [churchMembers, setChurchMembers] = useState([]);
  const [categoryList, setCategoryList] = useState();
  const [totalPaid, setTotalPaid] = useState();
  const [useOtherNonMember, setUseOtherNonMember] = useState(false);
  const [formData, setFormData] = useState({
    category_id: selectedRecord?.category_id?._id,
    income_title: selectedRecord?.dues_title,
    description: selectedRecord?.description,
    member_id: selectedRecord?.member_id?._id,
    income_dues_id: selectedRecord?._id,
    date: null,
    amount: null,
    status: null,
    income_source: null,
    other_non_member: null,
  });

  useEffect(() => {
    const getTotalPayment = (id) => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/incomedues/get-total-paid/${id}`;
      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          //console.log(response.data);
          setTotalPaid(response.data);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };
    getTotalPayment(selectedRecord?._id);
  }, []);

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/category/income/${user?.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then((response) => {
          const oldData = response.data.Categorys;
          const updatedData = oldData.map((data) => ({
            value: data?._id,
            label: data?.category_name,
          }));
          setCategoryList(updatedData);
        })
        .catch((err) => {
          console.log("error api call ", err.response.data.message);
        });
    };
    getDataFromServer();
  }, []);

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/church/${user?.church_id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then((response) => {
        const members = response?.data?.users;
        setChurchMembers(
          members.map((member) => ({
            value: member._id,
            label: member.first_name + " " + member.last_name,
          }))
        );
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error);
        errorLogApi(error, "ChurchMemberList", "/income");
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleAddIncome = (e) => {
    e.preventDefault();

    if (!formData?.income_source)
      return toast.error("Please select an income source");

    if (!formData?.status) return toast.error("Please select payment status");

    if (!formData?.amount) return toast.error("Please select payment amount");

    let userToken = localStorage.getItem("token");

    const finData = {
      ...formData,
      financial_year: financial_year?.label,
      dues_payment: true,
    };

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/income/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: finData,
    };

    axios(config)
      .then((response) => {
        toast.success("Receipt Created Successfully.");
        navigate("/income");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "IncomeAddChild", "/income/add");
      });
  };

  return (
    <div className="flex justify-center w-full min-h-screen p-8 bg-gray-100">
      <div className="w-full max-w-2xl p-8 bg-white rounded-lg shadow-lg">
        <form
          onSubmit={(e) => handleAddIncome(e)}
          autoComplete="off"
          className="space-y-6"
        >
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Add Receipt</h2>
            <div className="flex space-x-2">
              <button
                type="button"
                className="flex items-center px-4 py-2 text-white transition duration-300 bg-gray-600 rounded-md hover:bg-gray-700"
                onClick={() => navigate(-1)}
              >
                <FaArrowLeft className="mr-2" /> Back
              </button>
              <button
                type="submit"
                className="flex items-center px-4 py-2 text-white transition duration-300 bg-blue-600 rounded-md hover:bg-blue-700"
              >
                <FaPlus className="mr-2" /> Create
              </button>
            </div>
          </div>

          <div className="space-y-4">
            <Select
              name="category_id"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  category_id: selected.value,
                });
              }}
              options={categoryList}
              placeholder={
                <div className="flex items-center">
                  <FaListAlt className="mr-2" />{" "}
                  {placeHolderText("Select Category")}
                </div>
              }
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
              value={
                formData?.category_id &&
                categoryList?.find((c) => c.value === formData?.category_id)
              }
              isDisabled
            />

            <input
              className="w-full p-3 transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="income_title"
              type="text"
              required
              placeholder="Income Title"
              autoComplete="off"
              onChange={handleChange}
              value={formData?.income_title}
              disabled
            />

            <Select
              name="member_id"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  member_id: selected?.value,
                  other_non_member: null,
                });
              }}
              options={churchMembers}
              placeholder={
                <div className="flex items-center">
                  <FaUser className="mr-2" /> {placeHolderText("Select Member")}
                </div>
              }
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
              value={
                formData?.member_id &&
                churchMembers?.find((m) => m.value === formData?.member_id)
              }
              isDisabled
            />

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Pledged Amount
              </label>
              <input
                className="w-full p-3 transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="pledged_amount"
                type="number"
                required
                placeholder="Enter Amount"
                autoComplete="off"
                onChange={handleChange}
                value={selectedRecord?.pledged_amount}
                disabled
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Balance Amount
              </label>
              <input
                className="w-full p-3 transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="balance_amount"
                type="number"
                required
                placeholder="Enter Amount"
                autoComplete="off"
                onChange={handleChange}
                value={
                  totalPaid
                    ? +selectedRecord?.pledged_amount - +totalPaid
                    : selectedRecord?.pledged_amount
                }
                disabled
              />
            </div>

            <DatePicker
              className="w-full transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="date"
              format="MM-DD-YYYY"
              onChange={(date, dateString) => {
                setFormData({
                  ...formData,
                  date: dateString,
                });
              }}
              showToday={true}
              suffixIcon={<FaCalendarAlt className="text-gray-400" />}
            />

            <div className="relative">
              <FaDollarSign className="absolute text-gray-400 top-3 left-3" />
              <input
                className="w-full p-3 pl-10 transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                name="amount"
                type="number"
                required
                placeholder="Enter Amount"
                autoComplete="off"
                onChange={handleChange}
              />
            </div>

            <Select
              name="income_source"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  income_source: selected.label,
                });
              }}
              options={incomeSourceOptions}
              placeholder={placeHolderText("Select Source")}
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
            />

            <Select
              name="status"
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  status: selected.value,
                });
              }}
              options={paymentStatusOption}
              placeholder={placeHolderText("Select Status")}
              className="w-full"
              styles={{
                ...style,
                control: (provided) => ({
                  ...provided,
                  borderColor: "#e2e8f0",
                  "&:hover": {
                    borderColor: "#cbd5e0",
                  },
                }),
              }}
            />

            <textarea
              className="w-full p-3 transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              name="description"
              rows={3}
              placeholder="Income Description"
              autoComplete="off"
              onChange={handleChange}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default IncomeDuesReceiptChild;
